"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tile = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const React = __importStar(require("react"));
const StyledTile = styled_1.default.div `
	background: ${merlin_theme_1.default.colours.background.lighter};
	border-radius: ${merlin_theme_1.default.layout.radius.default};
	box-shadow: 0 1px 5px 0 ${merlin_theme_1.default.colours.shadow.default};
	padding: ${merlin_theme_1.default.layout.spacing.large};

	& :last-child {
		margin-bottom: 0;
	}

	${(props) => !props.imageUrl ? null : `
	::before {
		content: '';
		display: block;
		padding: 50% 0 0;
		border-top-left-radius: ${merlin_theme_1.default.layout.radius.default};
		border-top-right-radius: ${merlin_theme_1.default.layout.radius.default};
		margin: calc(0px - ${merlin_theme_1.default.layout.spacing.large});
		margin-bottom: ${merlin_theme_1.default.layout.spacing.large};
		background-color: ${props.imageBgColour || merlin_theme_1.default.colours.background.lighter};
		background-image: url(${props.imageUrl});
		background-size: ${props.imageSize || 'cover'};
		background-repeat: no-repeat;
		background-position: ${props.backgroundPosition || 'cover'};
	`}
	}
`;
const Tile = ({ children, imageUrl, imageSize, imageBgColour, backgroundPosition }) => {
    return (React.createElement(StyledTile, { imageUrl: imageUrl, imageSize: imageSize, imageBgColour: imageBgColour, backgroundPosition: backgroundPosition }, children));
};
exports.Tile = Tile;
//# sourceMappingURL=Tile.js.map